<ng-container *ngIf="vtbMortgage$ | async as vtbMortgage">
	<div class="flex flex-col gap-y-4">
		<app-mortgage-priority-selector
			[ngModel]="vtbMortgage.priority"
			(ngModelChange)="setPriority($event)"
		></app-mortgage-priority-selector>
		<app-input
			label="Principal amount"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="vtbMortgage?.amount"
			type="cents"
			(debounce)="setAmount($event)"
			[testHook]="testHooks.PrincipalAmount"
		></app-input>
		<app-input
			label="Term"
			[ngModel]="vtbMortgage.term"
			(debounce)="setTerm($event)"
			[testHook]="testHooks.Term"
		></app-input>
		<app-date-picker
			label="Maturity date"
			[ngModel]="vtbMortgage?.maturityDate"
			(ngModelChange)="setMaturityDate($event)"
			[testHook]="testHooks.MaturityDateDatePicker"
		></app-date-picker>
		<app-radio-group
			label="Interest rate type"
			type="compact"
			[items]="interestRateTypeOptions"
			[ngModel]="vtbMortgage.interestRateType"
			(ngModelChange)="setInterestRateType($event)"
			[testHook]="testHooks.InterestRateTypeRadioGroup"
		></app-radio-group>
		<div class="flex flex-col gap-y-2">
			<div class="flex gap-x-2 items-end justify-center">
				<ng-container *ngIf="vtbMortgage.interestRateType === variableRateType">
					<app-input
						label="Prime rate"
						type="number"
						[ngModel]="vtbMortgage.primeInterestRate"
						(debounce)="setPrimeInterestRate($event)"
						[endIcon]="ICON.PERCENTAGE"
						[testHook]="testHooks.PrimeRate"
					></app-input>
					<app-radio-group
						type="compact"
						[items]="interestRatePrimeOptions"
						[ngModel]="vtbMortgage.interestAbovePrime"
						(ngModelChange)="setAbovePrime($event)"
						[testHook]="testHooks.SetAbovePrimeRadioGroup"
					>
					</app-radio-group>
				</ng-container>

				<app-input
					label="{{
						vtbMortgage.interestRateType === variableRateType
							? 'Adjustment factor'
							: 'Interest Rate'
					}}"
					type="number"
					[ngModel]="vtbMortgage.interestRate"
					(debounce)="setInterestRate($event)"
					[endIcon]="ICON.PERCENTAGE"
					[testHook]="testHooks.Input"
				></app-input>
			</div>

			<app-checkbox
				type="clear"
				[ngModel]="vtbMortgage.interestOnlyPayments"
				(ngModelChange)="setInterestOnlyPayments($event)"
				[testHook]="testHooks.SetInterestOnlyPaymentsCheckbox"
				>Interest only payments</app-checkbox
			>
		</div>

		<app-input
			label="Regular payments"
			type="cents"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="vtbMortgage.regularPayments"
			(debounce)="setRegularPayments($event)"
			[testHook]="testHooks.RegularPayments"
		></app-input>
	</div>
</ng-container>
